import React, { Component } from "react";
import Gauge from "./Gauge";
import Rating from "./Rating";
import "./Statistics.css";
import DispatchGraph from "./Dispatch";
import { i18n_get_value, I18N_LABELS } from "../../i18n/i18n_scripts";

export default class Statistics extends Component {
  render() {
    const dispatchTime = Math.round(this.props.avgDispatchTime / 60);
    const preparationTime = Math.round(this.props.avgPreparationTime / 60);
    const drivingTime = Math.round(this.props.avgDrivingTime / 60);

    return (
      <div className="stats">
        <div className="stats-gauges">
          <Gauge
            {...this.props}
            // Kitchen time gauge
            label={i18n_get_value(I18N_LABELS.STATS_GAUGE_KITCHEN_LABEL)}
            value={preparationTime}
            units="min"
            maxValueMinutes="30"
          />
          <Gauge
            {...this.props}
            // "Preparation" (dispatch) time gauge
            label={i18n_get_value(I18N_LABELS.STATS_GAUGE_DISPATCH_LABEL)}
            value={dispatchTime}
            units="min"
            maxValueMinutes="15"
          />
          <Gauge
            {...this.props}
            // Driving time gauge
            label={i18n_get_value(I18N_LABELS.STATS_GAUGE_DRIVING_LABEL)}
            value={drivingTime}
            units="min"
            maxValueMinutes="30"
          />
          <Gauge
            {...this.props}
            // Total delivery time gauge
            label={i18n_get_value(I18N_LABELS.STATS_GAUGE_DELIVERY_LABEL)}
            // The delivery time should be the sum of the previous values
            // Even though we have this value from the API (avgDeliveryTime),
            // we sum them anyways to garantee the values do not round up and avoid showing a wrong summed value
            value={preparationTime + dispatchTime + drivingTime}
            units="min"
            maxValueMinutes="60"
          />
          <DispatchGraph {...this.props} />
          <div className="stats-reset"
              onClick={ this.props.onReset }
          >reset</div>
        </div>
        <Rating
          {...this.props}
          className="stats-rating"
          label="Average Rating"
        />
        {this.props.expectedDeliveryTime ? (
          <div className="expected-delivery-time">
            <span style={{ fontWeight: "lighter" }}>
              {i18n_get_value(I18N_LABELS.STATS_DELIVERY_TIME_LABEL)}:{" "}
            </span>
            {Math.round(this.props.expectedDeliveryTime) + " min"}
          </div>
        ) : null}
      </div>
    );
  }
}
